import { myCookie } from "../utils/myCookie";

let access_token = myCookie.get("access_token");

export default access_token;
